"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_1 = require("@phishtool/ui");
const react_router_dom_1 = require("react-router-dom");
const quote_1 = __importDefault(require("./quote"));
const form_1 = __importDefault(require("./form"));
const utility_page_1 = require("~components/utility-page");
const EnterpriseQuotePortal = () => {
    const [quote, setQuote] = (0, react_1.useState)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const match = location.pathname.match(/enterprise-quote-portal\/([^/]*)/);
    const token = (match === null || match === void 0 ? void 0 : match[1]) || '';
    return ((0, jsx_runtime_1.jsx)(utility_page_1.StyledUtilityPageWrapper, { children: (0, jsx_runtime_1.jsx)(ui_1.Grid, { children: (0, jsx_runtime_1.jsxs)(ui_1.Cell, { children: [(0, jsx_runtime_1.jsx)(utility_page_1.StyledUtilityPageHeading, { align: "center", children: "Quote portal" }), quote ? ((0, jsx_runtime_1.jsx)(quote_1.default, { quote: quote, token: token })) : ((0, jsx_runtime_1.jsx)(form_1.default, { token: token, setQuote: setQuote }))] }) }) }));
};
exports.default = EnterpriseQuotePortal;
